import { Component, Input, OnInit } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js/auto';
import { barView } from '../global-variables';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-bar-view',
    templateUrl: './bar-view.component.html',
    styleUrls: ['./bar-view.component.scss'],
    imports: [FormsModule]
})
export class BarViewComponent implements OnInit {
  @Input('values')
  set values(values: { xValues: string[], yValues: { promoters: number[], detractors: number[], passives: number[] }, numberOfUsersRated: number[] }) {
    this.xValues = values.xValues
    this.yValues = values.yValues
    this.numberofUsersRated = values.numberOfUsersRated
    this.onChange()
  }
  id = "bar"
  xValues: string[] = [];
  yValues: { promoters: number[], detractors: number[], passives: number[] } = {
    promoters: [],
    detractors: [],
    passives: []
  }
  numberofUsersRated: number[] = []
  chartData?: Chart;
  ngOnInit() {
    const max = Math.max(...this.numberofUsersRated)
    const stepSize = barView.scales.y.ticks.stepSize
    barView.scales.y.max = Math.ceil(max / stepSize) * stepSize
    this.prepareData()
  }
  prepareData() {
    const barPercentage = 0.5
    const data: ChartConfiguration = {
      type: 'bar',
      data: {
        labels: this.xValues,
        datasets: [
          {
            label: "Promoters",
            backgroundColor: "rgba(11, 113, 57, 1)",
            data: this.yValues.promoters,
            barPercentage: barPercentage,
          }, {
            label: "Passive",
            backgroundColor: "rgba(250, 180, 22, 1)",
            data: this.yValues.passives,
            barPercentage: barPercentage,
          }, {
            label: "Detractors",
            backgroundColor: "rgba(237, 36, 36, 1)",
            data: this.yValues.detractors,
            barPercentage: barPercentage
          },
        ],
      },
      options: {
        aspectRatio: 573/400,
        interaction: {
          mode: "index",
        },
        plugins: {
          tooltip: {
            titleColor: "black",
            backgroundColor: "white",
            bodyColor: "black",
            borderColor: "black",
            borderWidth: 0.1
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 30,
            }
          },
        },
        scales: barView.scales,
      }
    }

    this.chartData = new Chart(this.id, data);
  }
  onChange() {
    if (this.chartData) {
      this.chartData.data.labels = this.xValues;
      this.chartData.data.datasets[0].data = this.yValues.promoters
      this.chartData.data.datasets[1].data = this.yValues.passives
      this.chartData.data.datasets[2].data = this.yValues.detractors
      this.chartData.update()
    }
  }
}
